import {
    cancelLocalThunk as cancelLocalAppoinmentsListThunk,
    removeLocalThunk as removeLocalAppoinmentsListThunk,
    updateLocalThunk as updateLocalAppoinmentsListThunk
} from '@spike/appointments-list-action';
import {
    cancelSeveralLocalAppointmentThunk,
    cancelSeveralLocalBookingThunk,
    removeLocalAppointmentThunk,
    removeLocalBookingThunk,
    removeSeveralLocalAppointmentThunk,
    removeSeveralLocalBookingThunk,
    updateLocalAppointmentThunk,
    updateLocalBookingThunk
} from '@spike/bookings-action';
import { MasterData } from '@spike/masterdata-model';
import { AppointmentsWebSocketsMessage } from 'model/WebSockets';
import { Dispatch } from 'redux';
import { debugConsoleLog } from 'utils/GeneralUtils';
import { websocketLog } from '../websocketLog';

export const handleAppointmentsWebSocketMessage = (
    message: AppointmentsWebSocketsMessage,
    dispatch: Dispatch,
    masterData: MasterData,
    timeZone: string
): void => {
    websocketLog('message', 'AppointmentsWebSockets', {
        appointmentId: message.appointment?.id,
        bookingId: message.booking?.id,
        canceled: message.canceled,
        deleted: message.deleted
    });

    if (
        message.appointment &&
        (message.booking?.appointments || []).some(appointment => appointment.id === message.appointment?.id)
    ) {
        dispatch(updateLocalAppointmentThunk(message.appointment, masterData, timeZone));
        if (message.new_appt_payload) {
            dispatch(updateLocalAppoinmentsListThunk(message.new_appt_payload, masterData, timeZone));
        }
    }

    if (
        message.appointment &&
        !(message.booking?.appointments || []).some(appointment => appointment.id === message.appointment?.id)
    ) {
        dispatch(removeLocalAppointmentThunk(message.appointment.id));
        dispatch(removeLocalAppoinmentsListThunk([message.appointment.id]));
    }

    if (message.booking && message.booking.appointments) {
        dispatch(updateLocalBookingThunk(message.booking, masterData, timeZone));
    }

    if (message.booking && !message.booking.appointments) {
        dispatch(removeLocalBookingThunk(message.booking.id));
    }

    if (message.canceled && message.canceled.length > 0) {
        debugConsoleLog(`---> Canceled appointments, ids = ${message.canceled}`);
        dispatch(cancelSeveralLocalAppointmentThunk([...message.canceled], masterData));
        dispatch(cancelSeveralLocalBookingThunk([...message.canceled], masterData));
        dispatch(cancelLocalAppoinmentsListThunk([...message.canceled]));
    }

    if (message.deleted && message.deleted.length > 0) {
        debugConsoleLog(`---> Deleted appointments, ids = ${message.deleted}`);
        dispatch(removeSeveralLocalAppointmentThunk([...message.deleted]));
        dispatch(removeSeveralLocalBookingThunk([...message.deleted]));
        dispatch(removeLocalAppoinmentsListThunk([...message.deleted]));
    }
};
